<script>

  import {mapState} from "vuex";

  export default {
    name: "DashboardZeroStateBalances",
    computed: {
      ...mapState('app', ['theme'])
    }
  }
</script>

<template>
<div class="zero-balances">
  <div>
    <div class="title">{{ $t('payments.zero-state.all-balances') }}</div>
    <div class="subtitle">{{ $t('payments.zero-state.get-payments') }}</div>
    <div class="items">
      <div class="item">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_21575_306969)">
            <path d="M8 0C3.58189 0 0 3.58189 0 8C0 12.4181 3.58189 16 8 16C12.4181 16 16 12.4181 16 8C16 3.58189 12.4181 0 8 0ZM10.2979 11.1539C9.94897 11.5786 9.49465 11.865 8.96461 12.0099C8.73416 12.0724 8.62881 12.1942 8.64198 12.4346C8.65185 12.6716 8.64197 12.9053 8.63868 13.1424C8.63868 13.3531 8.53004 13.465 8.32263 13.4716C8.18765 13.4749 8.05267 13.4782 7.9177 13.4782C7.79918 13.4782 7.68066 13.4782 7.56214 13.4749C7.33827 13.4716 7.23292 13.3432 7.23292 13.1259C7.22963 12.9547 7.22963 12.7802 7.22963 12.6091C7.22634 12.2272 7.21317 12.214 6.84774 12.1547C6.38025 12.079 5.91934 11.9737 5.49136 11.7663C5.15556 11.6016 5.11934 11.5193 5.21481 11.1638C5.28724 10.9004 5.35967 10.637 5.44198 10.377C5.50123 10.186 5.5572 10.1004 5.65926 10.1004C5.71852 10.1004 5.79424 10.13 5.8963 10.1827C6.37037 10.4296 6.87407 10.5679 7.40411 10.6337C7.493 10.6436 7.58189 10.6502 7.67078 10.6502C7.9177 10.6502 8.15802 10.6041 8.39177 10.5021C8.98107 10.2453 9.07325 9.56379 8.57613 9.15556C8.40823 9.01728 8.21399 8.91523 8.01317 8.82634C7.4963 8.59918 6.95967 8.42798 6.47243 8.13498C5.6823 7.66091 5.18189 7.01235 5.24115 6.05103C5.307 4.96461 5.92263 4.28642 6.92016 3.92428C7.33169 3.77613 7.33498 3.77942 7.33498 3.35144C7.33498 3.20658 7.33169 3.06173 7.33827 2.91358C7.34815 2.59095 7.40082 2.53498 7.72346 2.5251H8.09877C8.71111 2.5251 8.71111 2.55144 8.7144 3.21317C8.7177 3.70041 8.7177 3.70041 9.20165 3.77613C9.57366 3.83539 9.92593 3.94403 10.2683 4.09547C10.456 4.17778 10.5284 4.30946 10.4691 4.51029C10.3835 4.80658 10.3012 5.10617 10.2091 5.39918C10.1498 5.57695 10.0938 5.65926 9.98848 5.65926C9.92922 5.65926 9.85679 5.63621 9.76461 5.59012C9.29053 5.35967 8.79342 5.24774 8.27325 5.24774C8.20741 5.24774 8.13827 5.25103 8.07243 5.25432C7.9177 5.2642 7.76625 5.28395 7.6214 5.3465C7.10782 5.57037 7.02551 6.13663 7.46337 6.4856C7.68395 6.66337 7.93745 6.78848 8.19753 6.89712C8.65185 7.08477 9.10617 7.26584 9.53745 7.50288C10.8938 8.26008 11.2626 9.98189 10.2979 11.1539Z" fill="var(--button-border-button-primary-default)"/>
          </g>
          <defs>
            <clipPath id="clip0_21575_306969">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <div class="item__title">
          {{ $t('payments.zero-state.total-balance') }}
        </div>
      </div>
      <div class="item">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.04084 2.85973C1.3335 3.83331 1.3335 5.2221 1.3335 7.99967C1.3335 10.7773 1.3335 12.166 2.04084 13.1396C2.26928 13.454 2.54579 13.7306 2.86022 13.959C3.83379 14.6663 5.22258 14.6663 8.00016 14.6663C10.7777 14.6663 12.1665 14.6663 13.1401 13.959C13.4545 13.7306 13.731 13.454 13.9595 13.1396C14.6668 12.166 14.6668 10.7773 14.6668 7.99967C14.6668 5.2221 14.6668 3.83331 13.9595 2.85973C13.731 2.5453 13.4545 2.2688 13.1401 2.04035C12.1665 1.33301 10.7777 1.33301 8.00016 1.33301C5.22258 1.33301 3.83379 1.33301 2.86022 2.04035C2.54579 2.2688 2.26928 2.5453 2.04084 2.85973ZM9.452 4.22084C9.66156 4.01047 9.91746 3.81144 10.2582 3.75716C10.3281 3.74602 10.3986 3.74042 10.4694 3.74042C10.5401 3.74042 10.6107 3.74602 10.6806 3.75716C11.0213 3.81144 11.2772 4.01047 11.4867 4.22084C11.6887 4.42361 11.9116 4.70477 12.1701 5.03077L12.88 5.92612C13.0706 6.16654 13.0303 6.51597 12.7898 6.7066C12.5494 6.89723 12.2 6.85686 12.0093 6.61644L11.3191 5.74584C11.2068 5.60423 11.1101 5.48256 11.0249 5.37777L11.0249 11.2096C11.0249 11.5164 10.7762 11.7651 10.4694 11.7651C10.1625 11.7651 9.91381 11.5164 9.91381 11.2096L9.91381 5.37778C9.82859 5.48256 9.73195 5.60423 9.61967 5.74584L8.92937 6.61644C8.73874 6.85686 8.38931 6.89723 8.14889 6.7066C7.90847 6.51597 7.8681 6.16654 8.05873 5.92612L8.76864 5.03078C9.02709 4.70478 9.25 4.42362 9.452 4.22084ZM6.08658 4.78968C6.08658 4.48285 5.83785 4.23412 5.53103 4.23412C5.2242 4.23412 4.97547 4.48285 4.97547 4.78968L4.97547 10.6215C4.89026 10.5167 4.79362 10.395 4.68133 10.2534L3.99104 9.38278C3.80041 9.14236 3.45098 9.102 3.21056 9.29263C2.97013 9.48326 2.92977 9.83269 3.1204 10.0731L3.83031 10.9685C4.08876 11.2944 4.31167 11.5756 4.51366 11.7784C4.72323 11.9888 4.97913 12.1878 5.31983 12.2421C5.38973 12.2532 5.4603 12.2588 5.53103 12.2588C5.60175 12.2588 5.67232 12.2532 5.74223 12.2421C6.08293 12.1878 6.33883 11.9888 6.54839 11.7784C6.75038 11.5756 6.97329 11.2945 7.23174 10.9685L7.94166 10.0731C8.13229 9.83269 8.09192 9.48326 7.8515 9.29263C7.61108 9.102 7.26164 9.14236 7.07101 9.38278L6.38072 10.2534C6.26844 10.395 6.1718 10.5167 6.08658 10.6215L6.08658 4.78968Z" fill="var(--button-border-button-primary-default)"/>
        </svg>
        <div class="item__title">
          {{ $t('payments.zero-state.swap-click') }}
        </div>
      </div>
      <div class="item">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5 5.25H13.5C12.9477 5.25 12.5 5.69772 12.5 6.25V13.75C12.5 14.3023 12.9477 14.75 13.5 14.75H14.5C15.0523 14.75 15.5 14.3023 15.5 13.75V6.25C15.5 5.69772 15.0523 5.25 14.5 5.25Z" fill="var(--button-border-button-primary-default)"/>
          <path d="M10.5 8.75H9.5C8.94772 8.75 8.5 9.19772 8.5 9.75V13.75C8.5 14.3023 8.94772 14.75 9.5 14.75H10.5C11.0523 14.75 11.5 14.3023 11.5 13.75V9.75C11.5 9.19772 11.0523 8.75 10.5 8.75Z" fill="var(--button-border-button-primary-default)"/>
          <path d="M6.5 7.25H5.5C4.94772 7.25 4.5 7.69772 4.5 8.25V13.75C4.5 14.3023 4.94772 14.75 5.5 14.75H6.5C7.05228 14.75 7.5 14.3023 7.5 13.75V8.25C7.5 7.69772 7.05228 7.25 6.5 7.25Z" fill="var(--button-border-button-primary-default)"/>
          <path d="M2.5 10.25H1.5C0.947715 10.25 0.5 10.6977 0.5 11.25V13.75C0.5 14.3023 0.947715 14.75 1.5 14.75H2.5C3.05228 14.75 3.5 14.3023 3.5 13.75V11.25C3.5 10.6977 3.05228 10.25 2.5 10.25Z" fill="var(--button-border-button-primary-default)"/>
          <path d="M13.265 4.0575C13.4825 4.18 13.7325 4.25 14 4.25C14.8275 4.25 15.5 3.5775 15.5 2.75C15.5 1.9225 14.8275 1.25 14 1.25C13.1725 1.25 12.5 1.9225 12.5 2.75C12.5 2.945 12.54 3.1325 12.6075 3.3025L10.735 4.9425C10.5175 4.82 10.2675 4.75 10 4.75C9.54 4.75 9.1275 4.9575 8.8525 5.285L7.5 4.7775V4.75C7.5 3.9225 6.8275 3.25 6 3.25C5.76473 3.25014 5.53278 3.30557 5.32287 3.41183C5.11296 3.51809 4.93097 3.67219 4.79156 3.86172C4.65216 4.05124 4.55925 4.27087 4.52033 4.5029C4.48141 4.73493 4.49757 4.97286 4.5675 5.1975L2.83 6.5C2.58481 6.33473 2.29569 6.24678 2 6.2475C1.1725 6.2475 0.5 6.92 0.5 7.7475C0.5 8.575 1.1725 9.2475 2 9.2475C2.23527 9.24736 2.46722 9.19193 2.67713 9.08567C2.88704 8.97941 3.06903 8.82531 3.20844 8.63578C3.34784 8.44626 3.44075 8.22663 3.47967 7.9946C3.51859 7.76257 3.50243 7.52464 3.4325 7.3L5.17 5.9975C5.4075 6.1575 5.6925 6.25 6 6.25C6.46 6.25 6.8725 6.0425 7.1475 5.715L8.5 6.2225V6.25C8.5 7.0775 9.1725 7.75 10 7.75C10.8275 7.75 11.5 7.0775 11.5 6.25C11.5 6.055 11.46 5.8675 11.3925 5.6975L13.265 4.0575Z" fill="var(--button-border-button-primary-default)"/>
        </svg>
        <div class="item__title">
          {{ $t('payments.zero-state.more') }}
        </div>
      </div>
    </div>
  </div>
  <div class="zero-balances__img">
    <img v-if="theme === 'light'" src="./assets/Apollo-svg.svg" alt="">
    <img v-else src="./assets/dark-zaro-state-img.svg" alt="">
  </div>
</div>
</template>

<style scoped lang="scss">
.zero-balances {
  padding: 30px;
  display: flex;
  justify-content: space-between;
  border-radius: 30px;
  background: var(--bg-background-secondary, #FFF);
  &__img {
    max-width: 100%;
    img {
      max-width: 100%;
    }
  }
  &.zero-balances__left {

  }
  .title {
    color: var(--text-text-primary, #000);
    font-size: 32px;
    font-weight: 500;
    line-height: 100%;
    margin-bottom: 10px;
  }
  .subtitle {
    color: var(--text-text-primary, #000);
    font-size: 16px;
    font-weight: 500;
    line-height: 100%;
    margin-bottom: 20px;
  }
  .items {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .item {
    display: flex;
    align-items: center;
    gap: 5px;
    &__title {
      color: var(--text-color-text-secondary, #8B81A0);
      font-size: 16px;
      font-weight: 500;
      line-height: 100%;
    }
  }
}
@media screen and (max-width: 1600px) {
  .zero-balances {
    flex-direction: column;
    gap: 15px;
  }
  .zero-balances__img {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
@media screen and (max-width: 900px) {
  .zero-balances {
    flex-direction: column;
    gap: 15px;
  }
  .title {
    font-size: 20px;
  }
  .subtitle {
    font-size: 13px;
  }
  .item__title {
    font-size: 13px;
  }
}
</style>
